import {
  Button,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Modal,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import firebase from "firebase";
import UrediRaspored from "./UrediRaspored";
import { Field, Form, Formik } from "formik";
import { TextField, Select, TextareaAutosize } from "formik-material-ui";
import _, { isNull, isUndefined } from "underscore";
import MyTextArea from "./MyTextArea";
///imports up

function EditTimeTable() {
  const [raspored, setRaspored] = useState(null);
  const [showDay, setShowDay] = useState(null);
  const [dayID, setDayID] = useState(null);

  const [addDayModal, setAddDayModal] = useState(false);

  function closeAddDayModal() {
    setAddDayModal(false);
  }

  const [stavkaModal, setStavkaModal] = useState(false);

  function closeStavkaModal() {
    setStavkaModal(false);
  }



  useEffect(() => {
    if (raspored === null) {
      // TODO FIX BUGGG HERE WITH [] and null
      firebase
        .database()
        .ref("EditPage/raspored")
        .once("value")
        .then((res) => {
          let data = res.val();

          setRaspored(isNull(data) ? [] : data);
          let ID_Day = isNull(data) ? 0 : Object.keys(data)[0];
          setDayID(ID_Day);
          setShowDay(isNull(data) ? [] : data[ID_Day]);
        });
    } else {
      let ID_Day = document.cookie
        .split("; ")
        .find((row) => row.startsWith("Day"));
      if (!isUndefined(ID_Day)) {
        let val = ID_Day.split("=")[1];
        setDayID(val);
        setShowDay(raspored[val]);
      }
    }




  }, [raspored, showDay]);

  function addNewDay(values) {
    let day = values.day_date
    if(Object.keys(raspored).includes(day)){
      alert("Datum već posotij")
      return;
    }

    setDayID(values.day_date);
    firebase
      .database()
      .ref("EditPage/raspored" + "/" + values.day_date)
      .set("");
    closeAddDayModal();
    window.location.reload(false);
  }

  function removeDay(){
    let bool  = window.confirm("Jeste li sigurni da želite obirsati dan " + dayID);
    if(bool){
      firebase.database().ref("EditPage/raspored"+"/"+dayID).remove()
      document.cookie = "Day= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
      window.location.reload(false);
    }

  }

  // Nested Components

  //STAVKA
  function StavkaForma(props) {
    const { stavka } = props;
    const [vrstaPredavanja, setvrstaPredavanja] = useState(null);

    function handleChange(e) {
      setvrstaPredavanja(e.target.value);
    }
    const newItem = {
      id: "",
      time: "",
      type: "",
      max_guests: "",
      name: "",
      ime: "",
      prezime: "",
      length: "",
      lokacija: "",
      opis:""
    };

    function handleSubmit(values) {


      let setValues = values;
      if (values.id === "") {
        setValues.id = setValues.time +""+ setValues.lokacija;
      }
      firebase
        .database()
        .ref("EditPage/raspored" + "/" + dayID + "/" + values.id)
        .set(setValues);
      window.location.reload(false);
    }

    return (
      <Grid
        style={{
          backgroundColor: "white",
          padding: "20px",
          border: "5px solid lightblue",
          margin: "10px",
        }}
        container
        direction="column"
      >
        <Formik
          initialValues={isNull(stavka) ? newItem : stavka}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          <Form>
            <Grid item>
              <Field
                component={TextField}
                name="time"
                label="Vrijeme predavanje"
                id="time"
                type="time"
                required
                style={{ width: "100%" }}
              />
            </Grid>

            <Grid item>
              <FormControl  style={{ width: "100%" }}>
                <InputLabel id="demo-simple-select-label" style={{ width: "100%" }}>
                  Vrsta izlaganja
                </InputLabel>
                <Field
                  style={{ width: "100%" }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  component={Select}
                  name="type"
                  inputProps={{
                    id: "type",
                    defaultValue: "",
                  }}
                >
                  <MenuItem   value={"Predavanje"}>Predavanje</MenuItem>
                  <MenuItem   value={"Radionica"}>Radionica</MenuItem>
                </Field>
              </FormControl>
            </Grid>

            <Grid item>
              <Field
                component={TextField}
                name="max_guests"
                label="Maksimalni broj gostiju"
                id="max_guests"
                type="number"
                required
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item>
              <Field
                component={TextField}
                name="name"
                label="Naziv predavanje"
                id="name"
                required
                type="text"
                style={{ width: "100%" }}
              />
            </Grid>

            <Grid item>

            <MyTextArea
            name="opis"
            rows="8"
            placeholder="Unesite opis događaja"
            style={{ width: "100%",marginTop:"10px"}}
            required
          />
              
               {/* <Field
                component={TextField}
                name="opis"
                label="Opis događaja"
                id="time"
                type="text"
                       multiline
          rowsMax={50}
                required
                style={{ width: "100%" }}
              />  */}
            </Grid>
            <Grid item>
              <Field
                component={TextField}
                name="ime"
                label="Ime predavaca"
                id="ime"
                required
                type="text"
                style={{ width: "100%" }}
              />
            </Grid>

            <Grid item>
              <Field
                component={TextField}
                name="prezime"
                label="Prezime predavaca"
                id="prezime"
                required
                type="text"
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item>
              <Field
                component={TextField}
                name="length"
                label="Trajanje Predavanja (min)"
                id="length"
                required
                type="number"
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item>
              <Field
                component={TextField}
                name="lokacija"
                label="Lokacija Predavanja "
                id="lokacija"
                required
                type="text"
                style={{ width: "100%" }}
              />
            </Grid>

            <Grid item style={{marginTop:"20px"}}>
              <Button type="submit" style={{backgroundColor:"#45B283",color:"white",width:"50%"}}>Spremi promjene</Button>

              <Button
              style={{backgroundColor:"#9A4E43",color:"white",width:"50%"}}
                type="button"
                onClick={() => {
                  closeStavkaModal();
                }}
              >
                Odustani
              </Button>
              </Grid>
          </Form>
        </Formik>
      </Grid>
    );
  }

  //RED
  function RedStavka(props) {
    const { ID, values, count } = props;

    const [uredi, setUredi] = useState(false);

    function closeUredi() {
      setUredi(false);
    }

    function removeStavka(){
      let bool  = window.confirm("Jeste li sigurni da želite obirsati Stavku ");
      if(bool){
        firebase.database().ref("EditPage/raspored"+"/"+dayID+"/"+ID).remove()
        document.cookie = "Day= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
        window.location.reload(false);
      }
    }

    return (
      <React.Fragment>
        <TableRow>
          <TableCell>{count}</TableCell>
          <TableCell>{values.time}</TableCell>
          <TableCell align="right">
            {values.ime + " " + values.prezime}
          </TableCell>
          <TableCell align="right">{values.type}</TableCell>
          <TableCell align="right">{values.name}</TableCell>
          <TableCell align="right">{values.max_guests}</TableCell>
          <TableCell align="right">{values.opis}</TableCell>
          <TableCell align="right">{values.length}</TableCell>
          <TableCell align="right">{values.lokacija}</TableCell>
          <TableCell align="right">
          <Button
            type="button"
            style={{backgroundColor:"#45B283",color:"white"}}
            onClick={() => {
              setUredi(true);
            }}
          >
            Uredi
          </Button>
          </TableCell>
          <TableCell align="right">
          <Button onClick={removeStavka}
           style={{backgroundColor:"#9A4E43",color:"white"}}
          >X</Button>
          </TableCell>




        </TableRow>

        <React.Fragment>
          <Modal
            open={uredi}
            onClose={closeUredi}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
          >
            <StavkaForma stavka={values} />
          </Modal>
        </React.Fragment>
      </React.Fragment>
    );
  }







  if (isNull(showDay) || isNull(raspored)) {
    return <CircularProgress />;
  }

  return (
    <Container textAlign="center" justifyContent="center" alignContent="center">
      <Grid container textAlign="center" justifyContent="center">
        <Grid
          item
          justify="center"
          alignContent="center"
          textAlign="center"
          justifyContent="space-around"
        >
          <Typography variant="h3">Uređivanje Rasporeda</Typography>

          {/* CHANGE DAY BUTTON */}
          <Grid item>
         
            {Object.keys(raspored).map((el, indx) => {
              return (
                <Button
                  color={dayID===el?"primary":"secondary"}
                  onClick={() => {
                    document.cookie = "Day=" + el;
                    setDayID(el);
                    setShowDay(raspored[el]);
                  }}
                >
                  {el}
                </Button>
              );
            })}
             <Button style={{backgroundColor:"#9A4E43",color:"white"}}onClick={removeDay}>Obriši Dan</Button>
          </Grid>

          {/* ADD NEW DAY BUTTON */}
          <Grid item>
            <Button
              style={{backgroundColor:"#1F94C2",color:"white",margin:"20px"}}
              onClick={() => {
                setAddDayModal(true);
              }}
            >
              Dodaj Novi dan
            </Button>

          </Grid>

          {/* ADD NEW DAY FORMA */}
          <React.Fragment>
            <Modal
              open={addDayModal}
              onClose={closeAddDayModal}
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              style={{margin:"20px auto",width:"50%"}}
            >
              <Grid
                style={{
                  backgroundColor: "white",
                  padding: "20px",
                  border: "5px solid lightblue",
                  margin: "10px",
                }}
                container
                direction="column"
              >
                <Grid item>
                  <Formik
                    initialValues={{
                      day_date: "",
                    }}
                    onSubmit={(values) => {
                      addNewDay(values);
                    }}
                  >
                    <Form>
                      <Grid item >
                        <Field
                          required
                          component={TextField}
                          name="day_date"
                          id="day_date"
                          lable="Upiši datum dana"
                          type="date"
                          style={{width:"100%"}}
                        />
                      </Grid>

                      <Container>
                      <Grid item style={{marginTop:"20px"}}>
                        <Button type="submit" style={{backgroundColor:"#1F94C2",color:"white",width:"50%"}}>Dodaj Novi dan</Button>


                        <Button
                        style={{backgroundColor:"#9A4E43",color:"white",width:"50%"}}
                          onClick={() => {
                            closeAddDayModal();
                          }}
                        >
                          Odustani
                        </Button>
                        </Grid>
                      </Container>
                    </Form>
                  </Formik>
                </Grid>
              </Grid>
            </Modal>
          </React.Fragment>

          {/* MODAL END */}

          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Vrijeme</TableCell>
                  <TableCell align="right">Predavac</TableCell>
                  <TableCell align="right">Tip</TableCell>
                  <TableCell align="right">Naslov</TableCell>
                  <TableCell align="right">Maksimalni broj gostiju</TableCell>
                  <TableCell align="right">Opis</TableCell>
                  <TableCell align="right">Duljina trajanja</TableCell>
                  <TableCell align="right">Lokacija</TableCell>
                  <TableCell align="right"></TableCell>
                  <TableCell align="right"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* MAPIRANJE STAVAKA START */}

                {Object.keys(showDay).map((el, indx) => {
                  return (
                    <RedStavka ID={el} values={showDay[el]} count={indx + 1} />
                  );
                })}



                {/* MAPIRANJE STAVAKA END */}
              </TableBody>

              {/* Modal Dovavanje Stavke */}
              <React.Fragment>
                <Modal
                  open={stavkaModal}
                  onClose={closeStavkaModal}
                  aria-labelledby="simple-modal-title"
                  aria-describedby="simple-modal-description"
                  style={{margin:"20px auto",width:"50%"}}
                >
                  <StavkaForma stavka={null} />
                </Modal>
              </React.Fragment>
              {/* MODLA END */}
              <Button
              style={{backgroundColor:"#1F94C2",color:"white",margin:"20px"}}
                onClick={() => {
                  setStavkaModal(true);
                }}
              >
                Dodaj Stavku Rasporeda
              </Button>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Container>
  );
}

export default EditTimeTable;
